import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import "../../styles/hydiene-system/hydiene.css";
import HelmetWrapper from "../../HelmetWrapper";
import PageStarter from "../../components/hygiene-system/hygiene-common/PageStarter";
import { selectAuth } from "../../components/auth/auth.selector";
import HygieneCategoryListings from "../../components/hygiene-system/categories/HygieneCategoryListings";
import { fetchHygieneCategoryData } from "../../redux/hygiene-reducers/hygieneSlice";
import AddHygieneCategoryForm from "../../components/hygiene-system/categories/AddHygieneCategoryForm";

const HygieneCategories = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const [pageLimit, setPageLimit] = useState(10);
  const [isPage, setIsPage] = useState(0);
  const iniAllFilter = {
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    limit: pageLimit || 10,
    page: isPage + 1,
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onCloseModalvalues = () => {
    setModValues(iniModvalues);
  };

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
      setIsPage(0);
    }
  };

  function getHygieneTasks(filters) {
    dispatch(
      fetchHygieneCategoryData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getHygieneTasks(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      limit: pageLimit || 10,
      page: isPage + 1,
    }));
  }, [pageLimit, isPage]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Daily Operation Checklist Status">
      <Container className="bg-cloud-k px-50px" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModalvalues}
          contentLabel="Hygiene Modal"
          ariaHideApp={false}
        >
          <div
            className={`createNewCTOModalContainer ${
              modValues.cardName === "add" || modValues.cardName === "edit"
                ? "mod-width-50p"
                : ""
            }`}
          >
            {modValues.cardName === "add" || modValues.cardName === "edit" ? (
              <AddHygieneCategoryForm
                userInfoData={userInfoData}
                callFunction={() => getHygieneTasks(filters)}
                closeModal={onCloseModalvalues}
                isEdit={modValues.cardName === "edit"}
                rowData={modValues.rowData}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <PageStarter
              pageName={"Checklist Statuses"}
              btnLabel={"+ Add new status"}
              searchPlaceHolder={"status"}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              onClickAdd={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }));
              }}
              isReload={() => getHygieneTasks(filters)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <HygieneCategoryListings
              userInfoData={userInfoData}
              setModValues={setModValues}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              callFunction={() => getHygieneTasks(filters)}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default HygieneCategories;
